// Keep in sync with the enum values of StageRunStatus in stage_run.py
export const STAGE_RUN_STATUS_INITIALIZED = 'INITIALIZED';
export const STAGE_RUN_STATUS_COMPLETED = 'COMPLETED';
export const STAGE_RUN_STATUS_DISCARDED = 'DISCARDED';
// This is not technically a status, but it similarly determines the shape of how the stage run is displayed
export const STAGE_RUN_STATUS_VIRTUAL = 'VIRTUAL';
// TODO(TypeScript): Rename to proper enum naming conventions.
export enum STAGE_RUN_STATUS {
  INITIALIZED = 'INITIALIZED',
  COMPLETED = 'COMPLETED',
  DISCARDED = 'DISCARDED',
}
export const STATUS_FRIENDLY_NAME = {
  [STAGE_RUN_STATUS_INITIALIZED]: 'Initialized',
  [STAGE_RUN_STATUS_COMPLETED]: 'Completed',
  [STAGE_RUN_STATUS_DISCARDED]: 'Discarded',
};
